import styled from "styled-components"

function Drawer({ show, close, fullScreen, styles, children, transition = true }: any) {
    const StyledDiv = styled.div`
        background-color : white;
        width : ${fullScreen ? '100%' : '60%'};
        position : fixed;
        top : 0;
        left : 0;
        z-index : 999999999;
        height : 100vh;
        overflow-y : auto;
    `
    return (
        show && 
        <div className={`${styles}`}>
            <StyledDiv className={`wrapper shadow-2xl ${transition && 'slide-from-left'}`} onClick={close}>
                {children}
            </StyledDiv>

            {/* BACKDROP */}
            {
                show &&
                <div onClick={close} className="opacity-70 fixed inset-0 z-40 bg-black"></div>
            }
        </div>
    )
}

Drawer.defaultProps = {
    styles : ''
}

export default Drawer